var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePaginatedToggleButton',{attrs:{"label":"Total # of PAX per route","main-list":_vm.itemData,"is-global-percent":_vm.isGlobalPercent,"override-headers":_vm.overrideHeaders}})
}
var staticRenderFns = []

export { render, staticRenderFns }